const API_URL = 'https://www.barcodepapel.pt:5017/api/payment';

const paymentService = {
  // Criar sessão de checkout Stripe
  async createCheckoutSession(bookingId, amount, successUrl, cancelUrl, paymentType) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token não encontrado');
      }
      console.log(JSON.stringify({
        bookingId,
        amount,
        successUrl,
        cancelUrl,
        paymentType,
      }))

      const response = await fetch(`${API_URL}/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          bookingId,
          amount,
          successUrl,
          cancelUrl,
          paymentType,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao criar sessão de pagamento');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao criar checkout:', error);
      throw error;
    }
  },

  // Verificar status do pagamento
  async verifyPayment(sessionId) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/verify/${sessionId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao verificar pagamento');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao verificar pagamento:', error);
      throw error;
    }
  },

  // Obter pagamentos do usuário
  async getUserPayments() {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/user`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao obter pagamentos');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao obter pagamentos:', error);
      throw error;
    }
  },

  // Admin: Obter todos os pagamentos
  async getAllPayments() {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/all`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao obter pagamentos');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao obter todos os pagamentos:', error);
      throw error;
    }
  },

  // Admin: Emitir reembolso
  async refundPayment(paymentId, reason) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token não encontrado');
      }

      const response = await fetch(`${API_URL}/admin/refund/${paymentId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ reason }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao processar reembolso');
      }

      return await response.json();
    } catch (error) {
      console.error('Erro ao processar reembolso:', error);
      throw error;
    }
  },
};

export default paymentService;